import { TableBody as MaterialTableBody } from '@mui/material'

import TableRow from '../TableRow'
import { Row } from '../TableRow/types'
import { TableBodyProps } from './types'


const TableBody = <T extends Row, U>({
  headers,
  small,
  children,
  rowAction,
  actions,
  hasBorders,
  rowColor,
  onRightClickRow,
  selectedRow,
  highlightedRows
}: TableBodyProps<T, U>) => {
  return (
    <MaterialTableBody>
      {children && children.map((row: T, rowIndex) => (
        <TableRow<T, U>
          key={rowIndex}
          highlightedRows={highlightedRows}
          headers={headers}
          small={small}
          actions={actions}
          onClickRow={rowAction}
          hasBorders={hasBorders}
          index={rowIndex}
          rowColor={rowColor}
          onRightClickRow={onRightClickRow}
          selected={selectedRow === rowIndex}
        >
          {row}
        </TableRow>
      ))}
    </MaterialTableBody>
  )
}

export default TableBody